<template>
    <v-client-table
    :data="items"
    :columns="columns"
    :options="options"
    ref="tableListeFacesDemandeSelected"
    class="">
        <template #sousType="{ row }">
            {{ $t(row.sousTypeLibelle) }}
        </template>
        <template #date="{ row }">
            {{ formatDate(row.dateDevisCommande) }}
        </template>
        <template #annonceur="{ row }">
           {{ getAnnonceurs(row)}}
        </template>
        <template #destinataire="{ row }">
          <qd-taginput
                v-model="row.mail.to"
                autocomplete
                allow-new
                :data="row.filteredContacts"
                group-field="nomCommercial"
                group-options="contacts"
                open-on-focus
                field="nomToDisplay"
                type="is-primary"
                expanded
                :disabled="disabled"
                @typing="e => onTyping(e, row)"
                @input="v => onChange(v, row)">
        </qd-taginput>
        </template>
    </v-client-table>
</template>

<script>
import cloneDeep from 'lodash/cloneDeep';
import {
  RESULTS_PER_POP_UP,
  NO_PER_PAGE_VALUE,
  SORT_ICON,
  TEXTS,
} from '@/configuration/clientTableConf';
import formatDate from '@/services/general/formatDate';

export default {
  props: {
    items: {
      type: Array,
      required: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      formatDate,
    };
  },
  computed: {
    options() {
      const texts = cloneDeep(TEXTS);
      texts.count = '';
      return {
        sortIcon: SORT_ICON,
        headings: {
          code: this.$t('listeFactures.envoiMailMasse.steps.selection.tab.code'),
          date: this.$t('listeFactures.envoiMailMasse.steps.selection.tab.date'),
          sousType: this.$t('listeFactures.envoiMailMasse.steps.selection.tab.sousType'),
          payeurLibelle: this.$t('listeFactures.envoiMailMasse.steps.selection.tab.payeur'),
          annonceur: this.$t('listeFactures.envoiMailMasse.steps.selection.tab.annonceur'),
          destinataire: this.$t('listeFactures.envoiMailMasse.steps.selection.tab.destinataire'),
        },
        filterable: false,
        perPageValues: NO_PER_PAGE_VALUE,
        perPage: RESULTS_PER_POP_UP,
        texts: texts,
        sortable: [],
        columnsClasses: {
          destinataire: 'is-min-width-500',
        },
      };
    },
    columns() {
      return ['code', 'date', 'sousType', 'payeurLibelle', 'annonceur', 'destinataire'];
    },
  },
  methods: {
    getAnnonceurs(row) {
      return row.annonceurs.map(a => a.nomCommercial).join(', ');
    },
    getFilteredContacts(row, search) {
      const selectedContactIds = row.mail.to.filter(c => c.id).map(c => c.id);
      const filtered = [];
      row.contacts.forEach(c => {
        const filteredFOrGroup = c.contacts.filter(c => !selectedContactIds.includes(c.id)
        && (!!search && c.nomToDisplay.includes(search)));
        if (filteredFOrGroup.length > 0) {
          filtered.push({ ...c, contacts: filteredFOrGroup });
        }
      });
      return filtered;
    },
    onChange(values, row) {
      const item = this.items.find(i => i.id === row.id);
      this.$set(item.mail, 'to', values);
      this.$set(item, 'filteredContacts', this.getFilteredContacts(row));
    },
    onTyping(text, row) {
      const item = this.items.find(i => i.id === row.id);
      this.$set(item, 'filteredContacts', this.getFilteredContacts(row, text));
    },
  },
};
</script>
